import { canonicalJsonStringify } from "@/lib/json-equality";

export const CHAPTER_SAVE_CONFLICT_MESSAGE =
    "This chapter changed since it was loaded. Reload to review the saved version; your unsaved writing is available to restore.";

/** Same content version in the browser and Node, independent of JSONB object key ordering. */
export async function getChapterContentHash(content: unknown): Promise<string> {
    const bytes = new TextEncoder().encode(canonicalJsonStringify(content));
    const digest = await globalThis.crypto.subtle.digest("SHA-256", bytes);
    return Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, "0")).join("");
}
